const IconSystemcheck = () => {
    return (
        <svg
            width="27"
            height="33"
            viewBox="0 0 27 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22.0308 14.9036V2.37695C22.0308 1.82467 21.5831 1.37695 21.0308 1.37695H1.6875C1.13522 1.37695 0.6875 1.82467 0.6875 2.37695V28.7903C0.6875 29.3426 1.13522 29.7903 1.6875 29.7903H11.3592"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
            />
            <mask id="path-2-inside-1_4553_149281" fill="white">
                <rect
                    x="3.83667"
                    y="4.28711"
                    width="15.0451"
                    height="6.37092"
                    rx="0.6"
                />
            </mask>
            <rect
                x="3.83667"
                y="4.28711"
                width="15.0451"
                height="6.37092"
                rx="0.6"
                stroke="currentColor"
                strokeWidth="2.6"
                mask="url(#path-2-inside-1_4553_149281)"
            />
            <path
                d="M4.46948 13.6035L14.5091 13.6035"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
            />
            <path
                d="M4.46948 17.7227H12.7305"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
            />
            <path
                d="M4.46948 26L14.5091 26"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
            />
            <path
                d="M4.46948 21.8613L12.7305 21.8613"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
            />
            <path
                d="M27.3355 30.4963H12.6646C12.5445 30.496 12.4264 30.4645 12.322 30.4051C12.2176 30.3457 12.1303 30.2602 12.0686 30.1571C12.01 30.052 11.9792 29.9336 11.9792 29.8132C11.9792 29.6929 12.01 29.5745 12.0686 29.4694L19.4041 16.6324C19.4693 16.534 19.5579 16.4533 19.6619 16.3975C19.7659 16.3417 19.8821 16.3125 20.0001 16.3125C20.1181 16.3125 20.2343 16.3417 20.3383 16.3975C20.4423 16.4533 20.5308 16.534 20.5961 16.6324L27.9315 29.4694C27.9901 29.5745 28.0209 29.6929 28.0209 29.8132C28.0209 29.9336 27.9901 30.052 27.9315 30.1571C27.8699 30.2602 27.7826 30.3457 27.6781 30.4051C27.5737 30.4645 27.4557 30.496 27.3355 30.4963ZM13.8475 29.1209H26.1527L20.0001 18.3562L13.8475 29.1209Z"
                fill="currentColor"
            />
            <path
                d="M20 25.4532C19.8184 25.4508 19.6448 25.3776 19.5164 25.2492C19.3879 25.1207 19.3147 24.9472 19.3123 24.7655V21.5562C19.3123 21.3739 19.3848 21.1989 19.5138 21.07C19.6427 20.941 19.8176 20.8686 20 20.8686C20.1824 20.8686 20.3573 20.941 20.4863 21.07C20.6153 21.1989 20.6877 21.3739 20.6877 21.5562V24.7655C20.6854 24.9472 20.6121 25.1207 20.4837 25.2492C20.3552 25.3776 20.1817 25.4508 20 25.4532Z"
                fill="currentColor"
            />
            <path
                d="M20 28.204C19.8184 28.2016 19.6448 28.1284 19.5164 27.9999C19.3879 27.8715 19.3147 27.6979 19.3123 27.5163V27.0578C19.3123 26.8754 19.3848 26.7005 19.5138 26.5716C19.6427 26.4426 19.8176 26.3701 20 26.3701C20.1824 26.3701 20.3573 26.4426 20.4863 26.5716C20.6153 26.7005 20.6877 26.8754 20.6877 27.0578V27.5163C20.6854 27.6979 20.6121 27.8715 20.4837 27.9999C20.3552 28.1284 20.1817 28.2016 20 28.204Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconSystemcheck;
